import React from 'react';

export const UnauthorizedPage: React.FC = () => {
  return <div>Missing auth token</div>;
};
